// extracted by mini-css-extract-plugin
export var typingIndicator = "_ra-0";